import { RouteRecordRaw } from 'vue-router'
// 路由

/**
 * meta:{
 *     title:'登录', 页面标题/菜单标题
 *     icon:'',     菜单图标
 *     hidden:true, 是否在菜单中以隐藏
 *     hiddenTab:true 是否在tab栏中隐藏
 *     permission: 菜单权限编码（对应localStorage中的permissionCodes）
 * }
 */

export const commonRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('@/layout/index.vue'),
    redirect: '/home',
    meta: {
      title: '首页',
      icon: 'dashboard',
    },
    children: [{
      path: '/home',
      name: 'home',
      component: () => import('@/views/Home/home.vue'),
      meta: {
        title: '首页',
        icon: '',
      },
    }]
  },
  // 登录
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login/index.vue'),
    meta: {
      title: '登录',
      icon: '',
      hidden: true,
      hiddenTab: true
    }
  },
  // 个人中心
  {
    path: '/user',
    component: () => import('@/layout/index.vue'),
    redirect: '/user/userInfo',
    meta: {
      title: '个人中心',
      icon: 'user',
      hidden: true,
      hiddenTab: true,
    },
    children: [{
      path: 'userInfo',
      name: 'userInfo',
      component: () => import('@/views/userCenter/userInfo.vue'),
      meta: {
        title: '个人中心',
        icon: '',
      },
    }]
  },
  //  系统管理
  {
    path: '/systemManage',
    component: () => import('@/layout/index.vue'),
    redirect: '/systemManage/chamberPermission',
    meta: {
      title: '系统管理',
      icon: 'setting',
      permission: 'system:manage:view'  // 系统管理查看权限
    },
    children: [{
      path: 'chamberPermission',
      name: 'chamberPermissionList',
      component: () => import('@/views/systemManage/chamberPermission/list.vue'),
      meta: {
        title: '商会权限管理',
        icon: '',
        permission: 'system:permission:list'  // 权限列表查看权限
      },
    }]
  },
  //  商会管理
  {
    path: '/chamber',
    component: () => import('@/layout/index.vue'),
    meta: {
      title: '商会管理',
      icon: 'user',
    },
    children: [{
      path: 'list',
      name: 'chamberList',
      component: () => import('@/views/chamberManage/list.vue'),
      meta: {
        title: '商会列表',
        icon: '',
        permission: 'manager:chamber:list'  // 商会列表查看权限
      },
    },{
      path: 'detail',
      name: 'chamberManageDetail',
      component: () => import('@/views/chamberManage/detail.vue'),
      meta: {
        title: '商会详情',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'chamber:update'
      }
    },{
      path: 'position',
      name: 'chamberManagePosition',
      component: () => import('@/views/chamberManage/position/list.vue'),
      meta: {
        title: '职务管理',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'position:list'
      }
    },{
      path: 'memberApplication',
      name: 'memberApplicationList',
      component: () => import('@/views/chamberManage/memberApplication/list.vue'),
      meta: {
        title: '入会申请审核',
        icon: '',
        permission: 'application:list'  // 入会申请列表查看权限
      }
    },{
      path: 'msglist',
      name: 'messageList',
      component: () => import('@/views/messageManage/message/list.vue'),
      meta: {
        title: '公告通知',
        icon: '',
        permission: 'message:list'  
      }
    },{
      path: 'member',
      name: 'chamberMemberManage',
      component: () => import('@/views/chamberManage/member/list.vue'),
      meta: {
        title: '商会成员管理',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'member:list'
      }
    }]
  },
  
   //  新闻资讯管理
   {
    path: '/news',
    component: () => import('@/layout/index.vue'),
    redirect: '/news/newsArticle',
    meta: {
      title: '新闻资讯管理',
      icon: 'form',
    },
    children: [{
      path: 'newsCategory',
      name: 'newsCategoryManage',
      component: () => import('@/views/newsManage/category/list.vue'),
      meta: {
        title: '栏目分类管理',
        icon: '',
        permission: 'admin:news:category:list'  // 栏目列表查看权限
      }
    },{
      path: 'newsTag',
      name: 'newsTagManage',
      component: () => import('@/views/newsManage/tag/list.vue'),
      meta: {
        title: '标签字典管理',
        icon: '',
        permission: 'admin:news:tag:list'  // 标签列表查看权限
      }
    },{
      path: 'newsArticle',
      name: 'newsArticleList',
      component: () => import('@/views/newsManage/article/list.vue'),
      meta: {
        title: '新闻资讯管理',
        icon: '',
        permission: 'news:list'  // 资讯列表查看权限
      }
    },{
      path: 'newsArticle/edit',
      name: 'newsArticleEdit',
      component: () => import('@/views/newsManage/article/edit.vue'),
      meta: {
        title: '编辑资讯',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'news:edit'
      }
    },{
      path: 'newsArticle/audit',
      name: 'newsArticleAudit',
      component: () => import('@/views/newsManage/article/audit.vue'),
      meta: {
        title: '新闻审核',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'news:audit'
      }
    },{
      path: 'supplyDemand',
      name: 'supplyDemandList',
      component: () => import('@/views/newsManage/article/supplyDemandList.vue'),
      meta: {
        title: '供需管理',
        icon: '',
        permission: 'admin:supplyDemand:list'  // 供需列表查看权限
      }
    },{
      path: 'supplyDemand/edit',
      name: 'supplyDemandEdit',
      component: () => import('@/views/newsManage/article/supplyDemandEdit.vue'),
      meta: {
        title: '编辑供需信息',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'news:supplyDemand:edit'
      }
    }]
  },
   //  活动管理
   {
    path: '/activity',
    component: () => import('@/layout/index.vue'),
    redirect: '/activity/list',
    meta: {
      title: '活动管理',
      icon: 'teaching',
    },
    children: [{
      path: 'list',
      name: 'activityList',
      component: () => import('@/views/activity/list.vue'),
      meta: {
        title: '活动列表',
        icon: '',
        permission: 'activity:list'  // 活动列表查看权限
      },
    },{
      path: 'detail',
      name: 'activityDetail',
      component: () => import('@/views/activity/detail.vue'),
      meta: {
        title: '活动详情',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'activity:detail'
      }
    },{
      path: 'manage',
      name: 'activityManage',
      component: () => import('@/views/activity/manage.vue'),
      meta: {
        title: '活动报名管理',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'activity:manage'
      }
    }]
  },
  {
    path: '/help',
    component: () => import('@/layout/index.vue'),
    meta: {
      title: '求助反馈管理',
      icon: 'report',
    },
    children: [{
      path: 'helpRequest',
      name: 'helpRequestList',
      component: () => import('@/views/helpManage/helpRequest/list.vue'),
      meta: {
        title: '求助列表',
        icon: '',
        permission: 'help:list'
      }
    },{
      path: 'feedback',
      name: 'feedbackList',
      component: () => import('@/views/helpManage/feedback/list.vue'),
      meta: {
        title: '反馈列表',
        icon: '',
        permission: 'feedback:list'
      }
    }]
  },
  //  专委会管理
  {
    path: '/specialCommittee',
    component: () => import('@/layout/index.vue'),
    redirect: '/specialCommittee/list',
    meta: {
      title: '专委会管理',
      icon: 'venue'
    },
    children: [{
      path: 'list',
      name: 'specialCommitteeList',
      component: () => import('@/views/specialCommittee/list.vue'),
      meta: {
        title: '专委会列表',
        icon: '',
        permission: 'sc:list'  // 专委会列表查看权限
      },
    },{
      path: 'detail',
      name: 'specialCommitteeDetail',
      component: () => import('@/views/specialCommittee/detail.vue'),
      meta: {
        title: '专委会详情',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'sc:detail'
      }
    },{
      path: 'position',
      name: 'specialCommitteePosition',
      component: () => import('@/views/specialCommittee/position/list.vue'),
      meta: {
        title: '专委会职务管理',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'sc:position:list'
      }
    },{
      path: 'member',
      name: 'specialCommitteeMember',
      component: () => import('@/views/specialCommittee/member/list.vue'),
      meta: {
        title: '专委会成员管理',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'sc:member:list'
      }
    }]
  },
  //  联络站管理
  {
    path: '/servicePoint',
    component: () => import('@/layout/index.vue'),
    redirect: '/servicePoint/list',
    meta: {
      title: '联络站管理',
      icon: 'station',
    },
    children: [{
      path: 'list',
      name: 'servicePointList',
      component: () => import('@/views/specialCommittee/servicePointList.vue'),
      meta: {
        title: '联络站列表',
        icon: '',
        permission: 'point:list'  // 联络站列表查看权限
      },
    },{
      path: 'detail',
      name: 'servicePointDetail',
      component: () => import('@/views/specialCommittee/servicePointDetail.vue'),
      meta: {
        title: '联络站详情',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'point:detail'
      }
    },{
      path: 'position',
      name: 'servicePointPosition',
      component: () => import('@/views/specialCommittee/position/list.vue'),
      meta: {
        title: '联络站职务管理',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'point:position:list'
      }
    },{
      path: 'member',
      name: 'servicePointMember',
      component: () => import('@/views/specialCommittee/member/list.vue'),
      meta: {
        title: '联络站成员管理',
        icon: '',
        hidden: true,
        hiddenTab: true,
        permission: 'point:member:list'
      }
    }]
  },
  //  Banner广告管理
  {
    path: '/bannerManage',
    component: () => import('@/layout/index.vue'),
    redirect: '/bannerManage/list',
    meta: {
      title: 'Banner广告管理',
      icon: 'Picture',
      permission: 'banner:list'  // Banner列表查看权限
    },
    children: [{
      path: 'list',
      name: 'bannerAdList',
      component: () => import('@/views/bannerManage/list.vue'),
      meta: {
        title: 'Banner广告列表',
        icon: '',
        permission: 'banner:list'  // Banner列表查看权限
      },
    }]
  },
 

  {
    path: '/:path(.*)*',
    component: () => import('@/views/err/404.vue'),
    meta: {
      title: '404',
      icon: '',
      hidden: true,
      hiddenTab: true
    }
  }
]